<template>
	<div class="analytics-page">
		<div class="analytics-page__head">
			<a :href="row.url" target="_blank" rel="noopener" class="analytics-page__link text-truncate" :title="row.url">{{ row.path }}</a>
			<span class="text-caption grey--text ml-2 text-no-wrap">ultimo mese: {{ row.last.toLocaleString('it-IT') }}</span>
			<v-btn v-if="apribile" icon x-small class="ml-1" :title="titoloLente" @click="$emit('open', row)">
				<v-icon small color="primary">mdi-magnify</v-icon>
			</v-btn>
		</div>
		<div class="analytics-page__months">
			<MonthCell v-for="(month, i) in months" :key="month" :month="month" :value="row.views[i]" :previous="precedente(i)" :pending="!letto(month)" />
		</div>
	</div>
</template>

<script>
import MonthCell from './MonthCell.vue';

const TITOLI = { item: 'Apri il prodotto', category: 'Apri la categoria', brand: 'Apri la marca', page: 'Apri la pagina' };

// Una pagina del sito: link e, sotto, le 12 caselle mensili
export default {
	name: 'PageRow',
	components: { MonthCell },
	props: {
		row: { type: Object, required: true },
		months: { type: Array, required: true },
		// mesi gia' scansionati da GA; null = tutti
		scanned: { type: Array, default: null },
	},
	computed: {
		// lente solo per le pagine che hanno un dettaglio nel BO (le home no)
		apribile() {
			const { section, reference, numericId } = this.row;
			if (!reference || !TITOLI[section]) return false;
			return section === 'item' || section === 'brand' || numericId != null;
		},
		titoloLente() {
			return TITOLI[this.row.section];
		},
	},
	methods: {
		letto(month) {
			return !this.scanned || this.scanned.includes(month);
		},
		// confronto solo tra due mesi gia' letti: un mese in attesa non e' uno 0
		precedente(i) {
			return i > 0 && this.letto(this.months[i - 1]) ? this.row.views[i - 1] : null;
		},
	},
};
</script>

<style scoped>
.analytics-page {
	padding: 10px 0;
	border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.analytics-page__head {
	display: flex;
	align-items: baseline;
	min-width: 0;
	margin-bottom: 6px;
}
.analytics-page__link {
	min-width: 0;
	font-weight: 500;
}
.analytics-page__months {
	display: grid;
	grid-template-columns: repeat(12, minmax(0, 1fr));
	gap: 6px;
}
@media (max-width: 960px) {
	.analytics-page__months {
		grid-template-columns: repeat(6, minmax(0, 1fr));
	}
}
@media (max-width: 480px) {
	.analytics-page__months {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}
}
</style>
